import { css } from '@eti/styles';

const linkStyles = css`
  height: 38px;
  width: auto;
`;

const storesImageStyles = css`
  height: 100%;
`;

interface MobileAppStoreProps {
  imageSrc: string;
  store: string;
  url: string;
}

const MobileAppStore = ({ imageSrc, store, url }: MobileAppStoreProps) => {
  return (
    <a
      className={linkStyles}
      data-testid={`${store}-link`}
      href={url}
      rel="noreferrer"
      target="_blank"
      type="button"
    >
      <img alt={store} className={storesImageStyles} src={imageSrc} />
    </a>
  );
};

export default MobileAppStore;
